import React from 'react';

import Typography from '@material-ui/core/Typography';

import Title from '../../components/Title/Title';

import useStyles from './Style';

const ObrigacoesProfessor = () => {
    const classes = useStyles();
    return (
        <>
            <Title id="anchor-08" className={classes.title}>
                8. OBRIGAÇÕES DO PROFESSOR
            </Title>

            <Typography className={classes.text} variant="body2">
                O professor, ao participar da Olimpíada de Professores da OBMEP Mirim, concorda em ter seu nome divulgado na lista de classificados e na lista de premiados da olimpíada, 
                bem como autoriza a utilização dos seus dados pessoais para cadastro e envio de convite para participação em programas acadêmicos realizados ou apoiados 
                pelo <span className={classes.bolder}> IMPA</span>.
            </Typography>
        </>
    )
}

export default ObrigacoesProfessor;